import * as React from 'react';
import { observer } from 'mobx-react';
import ModalReactions from '../../../../../../../../../Modal/ModalReactions';
import DetailsModal, { Props } from './DetailsModal';

const Details: React.FC<Props> = (props) => (
  <>
    <DetailsModal {...props} />
    <ModalReactions store={props.modalStore} />
  </>
);

export default observer(Details);
